import { render, staticRenderFns } from "./ClientSelect.vue?vue&type=template&id=34fbe0ec&scoped=true&"
import script from "./ClientSelect.vue?vue&type=script&lang=js&"
export * from "./ClientSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fbe0ec",
  null
  
)

export default component.exports